<div class="filter-dropdown city-dropdown">
	<button class="filter-selector" [matMenuTriggerFor]="cityMenu" #cityTrigger="matMenuTrigger">
		<div class="left">
			<mat-icon svgIcon="porto-bank-icons:location"></mat-icon>

			<span class="label">
				{{ selectedCity || 'Todas as cidades' }}
			</span>
		</div>

		<mat-icon svgIcon="porto-bank-icons:down-arrow" class="arrow" />
	</button>
</div>

<mat-menu #cityMenu="matMenu" class="filter-menu-panel city-menu-panel" xPosition="after">
	<div class="menu-content" (click)="$event.stopPropagation()">
		<button
			mat-menu-item
			(click)="selectCity(ALL_CITIES); cityTrigger.closeMenu()"
			[class.selected]="selectedCity === ALL_CITIES"
		>
			Todas as cidades
		</button>

		<button
			mat-menu-item
			*ngFor="let city of cities"
			(click)="selectCity(city); cityTrigger.closeMenu()"
			[class.selected]="selectedCity === city"
		>
			<mat-icon svgIcon="porto-bank-icons:check" *ngIf="selectedCity === city"></mat-icon>
			{{ city }}
		</button>
	</div>
</mat-menu>
